"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTemplate = void 0;
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
const FormTemplateFullWidth_1 = require("./FormTemplateFullWidth");
exports.FormTemplate = (props) => {
    const { xs = 4 } = props;
    return (React.createElement(material_1.Grid, { container: true, justifyContent: "center", alignItems: "stretch" },
        React.createElement(material_1.Grid, { container: true, item: true, justifyContent: "center", alignItems: "stretch", direction: "column", xs: xs },
            React.createElement(FormTemplateFullWidth_1.FormTemplateFullWidth, Object.assign({}, props)))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybVRlbXBsYXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZm9ybS10ZW1wbGF0ZS9Gb3JtVGVtcGxhdGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7O0dBTUc7QUFDSCw2Q0FBK0I7QUFDL0IsNENBQXFDO0FBR3JDLG1FQUFnRTtBQUVuRCxRQUFBLFlBQVksR0FBRyxDQUFDLEtBQWtELEVBQUUsRUFBRTtJQUNqRixNQUFNLEVBQUUsRUFBRSxHQUFHLENBQUMsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUN6QixPQUFPLENBQ0wsb0JBQUMsZUFBSSxJQUFDLFNBQVMsUUFBQyxjQUFjLEVBQUMsUUFBUSxFQUFDLFVBQVUsRUFBQyxTQUFTO1FBQzFELG9CQUFDLGVBQUksSUFBQyxTQUFTLFFBQUMsSUFBSSxRQUFDLGNBQWMsRUFBQyxRQUFRLEVBQUMsVUFBVSxFQUFDLFNBQVMsRUFBQyxTQUFTLEVBQUMsUUFBUSxFQUFDLEVBQUUsRUFBRSxFQUFFO1lBQ3pGLG9CQUFDLDZDQUFxQixvQkFBSyxLQUFLLEVBQUksQ0FDL0IsQ0FDRixDQUNSLENBQUM7QUFDSixDQUFDLENBQUMifQ==